import { type IGlobalTab, TabType } from '@carboncopyco/types/desktop';
import { memo } from 'react';
import { GroupRouter } from '../../../routers/GroupRouter';
import { HomeScreenRoute } from '../../../routes/HomeScreenRoute';
import OverlayScreen from '../../../routes/OverlayPage/OverlayPage';
import BrowserWindow from '../../../screens/BrowserWindow';
import CloningScreen from '../../../screens/CloningScreen';
import DemoPlayScreen from '../../../screens/DemoPlayScreen';
import { PresenterLinkScreen } from '../../../screens/PresenterLinkScreen';
import { PreviewCloneScreen } from '../../../screens/PreviewCloneScreen';
import { StartEditingScreen } from '../../../screens/StartEditingScreen';
import { TourTab } from '../../../screens/TourTab';
import TourTabContent from '../../../screens/TourTabContent';
import UpdateCloneScreen from '../../../screens/UpdateCloneScreen';

const TabPanelContent = ({
  tab,
  handleCloneUrlSelect,
  handleOverlayUrlSelect,
}: {
  tab: IGlobalTab;
  handleCloneUrlSelect: (url: string) => void;
  handleOverlayUrlSelect: () => void;
}) => {
  switch (tab.type) {
    case TabType.BASIC:
      return <HomeScreenRoute />;
    case TabType.CLONE:
      return (
        <CloningScreen
          tab={tab}
          onUrlSelect={(url) => handleCloneUrlSelect(url)}
        />
      );
    case TabType.OVERLAY_NEW:
      return (
        <OverlayScreen
          tab={tab}
          onUrlSelect={() => handleOverlayUrlSelect()}
        />
      );
    case TabType.OVERLAY_EDITOR:
    case TabType.MOBILE_DEMO_EDITOR:
    case TabType.DEMO_EDITOR:
      return (
        <div className="flex flex-col flex-grow flex-shrink-0 basis-auto">
          <StartEditingScreen
            demoId={Number(tab.payload.demo.id)}
            globalTab={tab}
          />
        </div>
      );
    case TabType.GROUP_TOUR_PRESENTATION:
    case TabType.GROUP_TOUR_PREVIEW:
      return <TourTabContent tab={tab} />;
    case TabType.TOURS_CREATE:
    case TabType.LIVE_TOURS_CREATE:
    case TabType.TOURS_PREVIEW:
    case TabType.TOURS_EDITOR:
      return <TourTab tab={tab} />;
    case TabType.PREVIEW_CLONE:
      return <PreviewCloneScreen tab={tab} />;
    case TabType.PREVIEW_OVERLAY:
    case TabType.PREVIEW_DEMO:
    case TabType.PRESENT_DEMO:
      return <DemoPlayScreen tab={tab} />;
    case TabType.GROUP_DEMO_PREVIEW:
    case TabType.GROUP_DEMO_PRESENTATION:
      return <GroupRouter tab={tab} />;
    case TabType.UPDATE_CLONE:
      return <UpdateCloneScreen tab={tab} />;
    case TabType.BROWSER_WINDOW:
      return <BrowserWindow tab={tab} />;
    case TabType.DEMO_MOBILE_PREVIEW:
    case TabType.GROUP_DEMO_MOBILE_PREVIEW:
      return <BrowserWindow tab={tab} />;
    case TabType.DEMO_MOBILE_PRESENTATION:
    case TabType.GROUP_DEMO_MOBILE_PRESENTATION:
      return <BrowserWindow tab={tab} />;
    case TabType.PRESENTER_DEEPLINK_DEMO:
    case TabType.PRESENTER_DEEPLINK_PLAYBOOK:
      return <PresenterLinkScreen tab={tab} />;
    default:
      return null;
  }
};

export default memo(TabPanelContent);
